import React from 'react';
import { CustomDialog } from 'components/dialog/CustomDialog';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const DatenschutzDialog: React.FC<IProps> = ({ open, onClose }) => (
  <CustomDialog open={open} handleClose={onClose} title="Datenschutz" maxWidth="md" className="psf-legal-dialog">
    <div className="psf-legal-dialog__body">
      <p>Bei Fragen zur Verarbeitung Ihrer persönlichen Daten oder zum Thema Datenschutz allgemein finden Sie entsprechende Informationen unter:</p>
      <p>
        <a href="https://www.sparkasse.de/datenschutz.html" target="_blank" rel="noopener noreferrer">
          https://www.sparkasse.de/datenschutz.html
        </a>
      </p>
      <p>
        Verantwortlich für diese Anwendung ist die Sparkassen-Finanzportal GmbH, Friedrichstraße 50, 10117 Berlin, E-Mail{' '}
        <a href="mailto:sparkasse@sparkassen-finanzportal.de">sparkasse@sparkassen-finanzportal.de</a>.
      </p>
    </div>
  </CustomDialog>
);
